// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__V9Y1z","load3":"Spinner_load3__29BFW"};